import { useMemo } from 'react';
import { countryOptions } from '@titrate/shared';

/**
 * Country picker. The list is built once from the ISO codes plus the
 * browser's own region names, with the countries most of our candidates
 * qualified in hoisted to the top.
 */
export function CountrySelect({
  id,
  value,
  onChange,
  required,
}: {
  id: string;
  value: string;
  onChange: (code: string) => void;
  required?: boolean;
}) {
  const options = useMemo(() => countryOptions(), []);
  const priority = options.filter((o) => o.priority);
  const rest = options.filter((o) => !o.priority);

  return (
    <select id={id} className="input" required={required} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="" disabled>
        Select a country…
      </option>
      <optgroup label="Common">
        {priority.map((o) => (
          <option key={o.code} value={o.code}>
            {o.name}
          </option>
        ))}
      </optgroup>
      <optgroup label="All countries">
        {rest.map((o) => (
          <option key={o.code} value={o.code}>
            {o.name}
          </option>
        ))}
      </optgroup>
    </select>
  );
}
